<template>
  <div :class="reportClass">
    <el-row>
      <el-col :span="6" class="logoSpace">
        <div class="logo">
          <img :src="header.logoUrl" alt>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="title">{{header.topicName}}</div>
      </el-col>
      <el-col :span="6">
        <div class="vipCenter">
          <el-row>
            <el-col :span="9" :offset="5" class="myPic myReport">
              <el-dropdown placement="top" :hide-timeout="hideTime">
                <span>我的报告</span>
                <el-dropdown-menu slot="dropdown" v-if="reportList.length>0 && type !=1">
                  <el-dropdown-item
                    v-for="(item,index) in reportList"
                    @click.native="myReport(item)"
                    :key="index"
                  >{{item.moduleName}}</el-dropdown-item>
                  <!-- :divided="index == '1'? true: false" -->
                </el-dropdown-menu>
                <el-dropdown-menu slot="dropdown" v-else-if="newReportList.length>0 && type ==1">
                  <el-dropdown-item
                    v-for="(item,index) in newReportList"
                    @click.native="myReport(item)"
                    :key="index"
                  >{{item.moduleName}}</el-dropdown-item>
                  <!-- :divided="index == '1'? true: false" -->
                </el-dropdown-menu>
                <el-dropdown-menu slot="dropdown" v-else>
                  <el-dropdown-item>暂无报告</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
            <el-col :span="9" class="myPic myCenter">
              <span @click="myCenter">{{header.userName}}</span>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  getToken,
  initSocketMsgData,
  getUserLocalData
} from '@/utils/auth'
import Bus from '@/utils/bus.js'
import { isSSAI } from '@/utils/index.js'
export default {
  name: "Header",
  data() {
    return {
      divided: false,
      hideTime: 1000,
      header: {
        logoUrl: require("../assets/images/logo.png"),
        topicName: "牛顿定律运动规律",
        userName: "吴晓磊"
      },
      dropMeun: [],
      type: '',
      newReportList: []
    };
  },
  props: {
    reportList: Array,
  },

  computed: {
    reportClass(){
      if(this.reportList && this.reportList.length >0){
        return 'headerBgReport'
      }else{
        return 'headerBg'
      }
    }
  },

  mounted() {
    if (this.dropMeun) {
    }
    let userData = getUserLocalData();
    this.header.topicName = userData.topicName;
    this.header.userName = userData.realName || userData.userName;
    Bus.$on('reportList', (e) => {
      this.newReportList = e
      this.type = 1
    })

  },
  methods: {
    myReport(item) {
      // this.$emit("myReport", "报告所需参数");
      let ext = item.ext;
      let query = ''
      for(let [k, v] of Object.entries(ext)){
        query += k + '=' + v + '&'
      }
      query = query.slice(0, -1)

      //监课信息
      const msg = {
        'event': 'GET_REPORT',
        'module_type': item.moduleType,
        'module_name': item.moduleName,
        'submodule_type': item.sModuleType,
        'submodule_name':  '',
        'report_url': window.location.protocol + "//" + window.location.host + item.routerId + '?' + query,
        'report_depth': 3
      }
      window.Monitor.getReport(msg);
      if(isSSAI()){
          const targetUrl = window.location.protocol + "//" + window.location.host + '/' + item.routerId + '?' + query;
         window.location.href = targetUrl;
      }else{
        if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.appJs){ //判断客户端
          const url = window.location.protocol + "//" + window.location.host + '/' + item.routerId + '?' + query
          
          try {
            window.webkit.messageHandlers.appJs.postMessage('{"action":"openReportPage","callback":"","params":"'+url+'"}')
          } catch (error) {
            console.log('ipad不支持window.webkit.messageHandlers对象')
          }
        }else{
          window.open( item.routerId + '?' + query, "_blank");
        }
      }
    },
    myCenter() {
      this.$emit("myCenter", "报告中心所需参数");
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme/register.scss';
.headerBg {
  color: #fff;
  .logoSpace {
    display: flex;
    justify-content: center;
    .logo {
    width: 170px;
    height: 34px;
    margin-top: 13px;
      img{
        width: 100%;
      }
    }
  }
  .title{
    text-align: center;
    font-weight: 600;
  }
  .myPic {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;

  span {
    line-height: 60px;
  }
}
}

.headerBgReport {
  color: #fff;
  .logoSpace {
    display: flex;
    justify-content: center;
    .logo {
    width: 115px;
    height: 42px;
    margin-top: 5px;
      img{
        width: 100%;
      }
    }
  }
  .title{
    text-align: center;
  }
  .myPic {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;

  span {
    line-height: 60px;
  }
}
}

.el-dropdown {
  color: $theme-text-color-white;
  font-size: inherit;
}
.el-dropdown-menu__item {
  text-align: center;
}
.el-dropdown-menu {
  li:hover {
    color: $theme-text-color;
    background: none;
  }
}

@media only screen and (max-width : 1024px) {

  //当屏幕最大1024时，执行下面css
  .myPic.myReport{
    width:100px;
    &.el-col-offset-5{
      margin-left: 18%;
    }
    .el-dropdown{
      width:100%;
      .el-dropdown-selfdefine{
        width:100%;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }
}
@media only screen and (max-width : 768px) {

  //当屏幕最大768时，执行下面css
  .myPic{
    max-width:50px;
  }
  .myPic.myReport{
    max-width:50px;
    &.el-col-offset-5{
      margin-left: 20%;
    }
    .el-dropdown{
      width:100%;
      .el-dropdown-selfdefine{
        width:100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        display: inline-block;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Header.vue